import {
  Cake,
  Camera,
  Certificate,
  Confetti,
  Envelope,
  FlowerLotus,
  Dress,
  MusicNotes,
  PawPrint,
  Scissors,
  Storefront,
  Van,
  VideoCamera,
} from "@phosphor-icons/react";

export const SUPPLIER_CATEGORIES = [
  { name: "Celebrants", icon: Certificate },
  { name: "Florists & Stylists", icon: FlowerLotus },
  { name: "Photographers", icon: Camera },
  { name: "Videographers", icon: VideoCamera },
  { name: "Hair & Makeup", icon: Scissors },
  { name: "Wedding Gowns", icon: Dress },
  { name: "Music, Bands & DJs", icon: MusicNotes },
  { name: "Reception Entertainment", icon: Confetti },
  { name: "Photobooths", icon: Camera },
  { name: "Transport", icon: Van },
  { name: "Cakes", icon: Cake },
  { name: "Invitations & Signage", icon: Envelope },
  { name: "Pets & Animals", icon: PawPrint },
];

export const SUPPLIER_CATEGORY_NAMES = SUPPLIER_CATEGORIES.map((c) => c.name);

export function categoryIcon(name) {
  return SUPPLIER_CATEGORIES.find((c) => c.name === name)?.icon || Storefront;
}

export function categorySlug(value) {
  return String(value).toLowerCase().replaceAll(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
